/**
 * Ajax (load more / filtering)
 *
 * @uses axios
 */

function find_ancestor (el, sel) {
  while ((el = el.parentElement) && !((el.matches || el.matchesSelector).call(el,sel))) {
    // shrug
  }

  return el;
}

function get_parameter_by_name(name, url) {
  if (!url) {
    url = window.location.href;
  }

  name = name.replace(/[\[\]]/g, "\\$&");

  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);

  if (!results) {
    return null;
  }

  if (!results[2]) {
    return '';
  }

  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

/**
 * @see https://stackoverflow.com/a/6021027
 */
function update_query_string_parameter(uri, key, value) {
  var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
  var separator = uri.indexOf('?') !== -1 ? "&" : "?";
  if (uri.match(re)) {
    return uri.replace(re, '$1' + key + "=" + value + '$2');
  }
  else {
    return uri + separator + key + "=" + value;
  }
}

var fetching = false;
var ajax_check_url = '';

/**
 * Get results with ajax
 *
 * @param url the target url
 * @param type the type of request pagination|filter
 * @param replace_history true|false to update url
 */
function cor_filter_ajax(args) {

  console.log( args );

  var url  = args.url;
  var type = args.type;
  var replace_history = args.replaceHistory;

  var container          = (typeof args.container !== 'undefined') ? args.container : document.querySelector('.js-ajax-container');
  var grid               = container.querySelector('.js-grid');
  var pagination         = container.querySelector('.js-pagination');
  var container_attr_id  = container.getAttribute('data-cor-ajax-container');

  var new_url = url;

  // skip multiple requests to same url
  if (ajax_check_url == new_url) {
    console.log('Duplicate url: ' + ajax_check_url + ' <=> ' + url);
    return;
  }

  // update url
  ajax_check_url = new_url;

  // prevent simultation requests
  if (fetching === false && typeof axios !== 'undefined' && container && grid) {
    fetching = true;

    // set ajax "state"
    container.classList.add('state--loading');
    if (type == 'filter') {
      container.classList.add('state--loading-big');
    }

    // remove focus
    document.activeElement.blur();

    axios.get(url)
      .then(function (response) {

        /**
         * Parse response into HTML DOM
         */
        var parser = new DOMParser();
        var html = parser.parseFromString(response.data, "text/html");
        //console.log(html);

        /**
         * Set document title and history, not on related-block.
         */
        if (window.history.pushState && !replace_history) {
          document.title = html.title;
          window.history.pushState(new_url, html.title, new_url);
        }

        var new_container = html.querySelector('[data-cor-ajax-container="' + container_attr_id + '"]');
        if ( ! new_container) {
          new_container = html.querySelector('.js-ajax-container');
        }
        if ( ! new_container) {
          console.log('No container found in new content');
        }


        /**
         * Grid
         */
        var new_grid = new_container.querySelector('.js-grid');
        if (new_grid && container) {

          // add entrance effect
          var items = new_grid.childNodes;

          for (var i = 0; i < items.length; i++) {
            if (typeof items[i].classList !== 'undefined') {
              items[i].classList.add('animation--entrance');
            }
          }
          grid.classList.add('animation--entrance');
          grid.innerHTML = new_grid.innerHTML;
        }

        /**
         * Query meta
         */
         var query_meta = container.querySelector('.js-query-meta');
         var new_query_meta = new_container.querySelector('.js-query-meta');
         if (query_meta && new_query_meta) {
          query_meta.innerHTML = new_query_meta.innerHTML;
         }

        /**
         * Filters
         */
        if (type == 'filter') {
          var filters = container.querySelector('.js-filters');
          var new_filters = new_container.querySelector('.js-filters');
          if (filters && new_filters) {
            filters.innerHTML = new_filters.innerHTML;
            // init filters
            cor_filters( container );
          }
        }

        /**
         * Pagination
         */
        var new_pagination = new_container.querySelector('.js-pagination');
        if (new_pagination && pagination) {
          pagination.innerHTML = new_pagination.innerHTML;
        } else {
          pagination.innerHTML = '';
        }

        /**
         * Popular filters
         */
        var popular_filters = container.querySelector('.js-filters-popular-wrapper');
        var new_popular_filters = new_container.querySelector('.js-filters-popular-wrapper');
        if (popular_filters && new_popular_filters) {
          popular_filters.outerHTML = new_popular_filters.outerHTML;
          popular_filters.classList.remove('is-hidden');
        } else if (popular_filters) {
          popular_filters.classList.add('is-hidden');
        }

        /**
         * Setup numbered pagination hooks
         */
        if (typeof cor_numbered_pagination_hooks === 'function') {
          cor_numbered_pagination_hooks();
        }

        // Remove ajax "state"
        container.classList.remove('state--loading');
        if (type == 'filter') {
          container.classList.remove('state--loading-big');
        }

        /**
         * Animation time
         */
        setTimeout(function(){
          var animation_items = document.querySelectorAll('.animation--entrance');
          if (animation_items.length) {
            for (var i = animation_items.length - 1; i >= 0; i--) {
              if (typeof animation_items[i].classList !== 'undefined') {
                animation_items[i].classList.remove('animation--entrance');
              }
            }
          }
        }, 250);

        /**
         * Send event that ajax is done
         */
        var event = new Event('cor_ajax_complete');
        window.dispatchEvent(event);

      })
      .catch(function (error) {
        console.log(error);
      });

  }
  fetching = false;

}
